'use strict';

var react = require('@emotion/react');

const topAlignment = /*#__PURE__*/ react.css({
    alignItems: "baseline"
}, "label:label-Checkbox-web-stylestopAlignment", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2JlbmFpYWhiYXJhbmdvL2Rldi9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9hdG9tcy9DaGVja2JveC9DaGVja2JveC53ZWIuc3R5bGVzLnRzIiwic291cmNlcyI6WyIvVXNlcnMvYmVuYWlhaGJhcmFuZ28vZGV2L2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL2F0b21zL0NoZWNrYm94L0NoZWNrYm94LndlYi5zdHlsZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5cbmV4cG9ydCBjb25zdCB0b3BBbGlnbm1lbnQgPSBjc3Moe1xuICBhbGlnbkl0ZW1zOiBcImJhc2VsaW5lXCIsXG59KTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEIifQ== */");

exports.topAlignment = topAlignment;
//# sourceMappingURL=Checkbox.web.styles.cjs.map
